import { css } from "styled-components";
import { fontFamily, fontStyle } from "./font";

export const typography = {
    title1: css`
        ${fontStyle.base}
        font-weight: 700;
        font-size: 24px;
        line-height: 1.3;
    `,
    title2: css`
        ${fontStyle.base}
        font-weight: 700;
        font-size: 18px;
        line-height: 125%;
    `,
    title3: css`
        ${fontStyle.base}
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
    `,
    body1: css`
        ${fontStyle.base}
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
    `,
    body2: css`
        ${fontStyle.base}
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
    `,
    caption: css`
        ${fontStyle.base}
        font-weight: 400;
        font-size: 10px;
        line-height: 1.5;
    `,
    button: css`
        ${fontStyle.base}
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
    `,
    tag: css`
        ${fontStyle.base}
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
    `
};

export type TypographyKeyTypes = keyof typeof typography;
